import { postJSON } from '@/services/httpService';

export const createToken = (body) =>
  postJSON(`/external-payment/validate`, body);

export const lookupCreditCardBIN = (body) =>
  postJSON(`/external-payment/bin_lookup`, body);
